/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {CTitle, TTitle} from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  return (
    <div className="topic-section-1">
      <CTitle title={paragraphsSettings?.title} />
      <div className="cycle-overview">
         <div className="cycle-overview-left">{paragraphsSettings?.l1}</div>
         <div className="cycle-overview-right">{paragraphsSettings?.l2}</div>
      </div>
      <TTitle title={paragraphsSettings?.tips} />
      <div className="cycle-list">
         <div className="cycle-list-left">
           <div className="list-box">
             {
               paragraphsSettings?.cycleList?.map((item:any, i:any) => (
                 <div className="left-item" key={i}>
                   <span>{item.id}</span>
                   <span>{item.title}</span>
                 </div>
               ))
             }
           </div>
         </div>
         <div className="cycle-list-right">
           {
             paragraphsSettings?.cycleList?.map((item:any, i:any) => (
               <div className="right-item" key={i}>
                 <span>{item.title}</span>
                 <span>{item.text}</span>
               </div>
             ))
           }
         </div>
      </div>
    </div>
  );
};

export default Section1;
